import {
  SCENARIO__CREATE,
  SCENARIO__EDIT_IMPLEMENTED_PLAN,

  INVESTMENT_PROPOSAL__CREATE
} from './useFeatureConfig.constants'

/**
 * FeatureOptionsProvider returns an object with a consistent interface from
 * which a client can retrieve feature configuration options, using the method
 * `getOptions`.
 */
export default function FeatureOptionsProvider(getFeatureOption) {
  return {
    getOptions(featureName, args = {}) {
      switch (featureName) {
        case SCENARIO__CREATE:
          return {
            clientScenarioCount: getFeatureOption('scenario-planning', 'clientScenarioCount')
          }
        case SCENARIO__EDIT_IMPLEMENTED_PLAN:
          return {
            historicScenarioCount: getFeatureOption('scenario-planning', 'historicScenarioCount')
          }

        case INVESTMENT_PROPOSAL__CREATE:
          const dfmIntegrationConfigs = getFeatureOption('dfm-integrations')
          const dfmIntegrationConfig = (dfmIntegrationConfigs || [])
            .find(e => e.slug === args.dfmIntegrationSlug)

          return { dfmIntegrationConfig }

        default:
          throw new Error(`${featureName} not recognised by FeatureOptionsProvider.`)
      }
    }
  }
}
